import { useCallback, useRef, useState } from "react";
import axios from "axios";
import config from "../../../config";

const EMPTY_IDS = [];

const useExitIds = () => {
  const [exitIds, setExitIds] = useState(EMPTY_IDS);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Only the latest request may update state, so fast approach switching can't
  // leave a stale exit highlight from an earlier, slower response
  const requestIdRef = useRef(0);

  const fetchExitIds = useCallback((approachId) => {
    const requestId = ++requestIdRef.current;
    setExitIds(EMPTY_IDS);
    setLoading(true);
    setError(null);
    return axios
      .get(`${config.FLYOVER_RCM_API_URL}/exit/ids/${approachId}`, {
        headers: { "X-API-Key": config.FLYOVER_RCM_API_TOKEN },
      })
      .then((res) => {
        if (requestId !== requestIdRef.current) return;
        setExitIds(res.data?.data ?? []);
      })
      .catch((err) => {
        if (requestId !== requestIdRef.current) return;
        console.error("useExitIds: fetch failed", err);
        setExitIds(EMPTY_IDS);
        setError(err);
      })
      .finally(() => {
        if (requestId === requestIdRef.current) setLoading(false);
      });
  }, []);

  const clearExitIds = useCallback(() => {
    requestIdRef.current += 1;
    setExitIds(EMPTY_IDS);
    setLoading(false);
  }, []);

  return { exitIds, loading, error, fetchExitIds, clearExitIds };
};

export default useExitIds;
